import React from 'react';
import { SearchParams } from '@spa/lib/pages/SearchParams';

export const RuntimeSearchParamsContext = React.createContext<SearchParams | null | undefined>({});
